module.exports = __webpack_public_path__ + "static/media/speaker_body_point_left.2ce5504a.png";